import { useQuery } from '@tanstack/react-query'
import { backgroundsService } from '@/api/services/backgrounds.service'
import { queryKeys } from '@/api/query-keys'

export function useBackgroundKeywordsQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.backgrounds.keywords(),
    queryFn: () => backgroundsService.getBackgroundKeywords(),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
